import { render, staticRenderFns } from "./DepartmentChairManageView.vue?vue&type=template&id=1fbcf6e2&scoped=true&"
import script from "./DepartmentChairManageView.vue?vue&type=script&lang=js&"
export * from "./DepartmentChairManageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbcf6e2",
  null
  
)

export default component.exports